/**
 * Baut die URL fuer eine ANDERE Subdomain derselben Basis-Domain, indem nur das erste
 * Hostname-Label ersetzt wird - dieselbe Technik wie `switchTenant` in `ui/AppShell.tsx`.
 * Gebraucht von zwei Stellen im Admin-Panel/Impersonation-Fluss (P3):
 *  - `pages/admin/tenant-detail.tsx`: springt nach dem Start einer Impersonation auf die normale
 *    Subdomain des Zielmandanten.
 *  - `ui/ImpersonationBanner.tsx`: springt nach dem Beenden zurueck auf `maestro.<basis>`.
 *
 * Es gibt bewusst KEINE `APP_BASE_DOMAIN`-Konstante im Frontend: das Backend kennt sie aus der
 * Umgebung, der Browser kennt nur seinen eigenen `window.location.hostname` - genau daraus leitet
 * diese Funktion die Basis-Domain ab, statt sie zu duplizieren (die muesste sonst bei jedem
 * Domain-Wechsel an zwei Stellen synchron gehalten werden).
 *
 * Lokale Dev-Hosts ohne Subdomain (`localhost`, ein einzelnes Label) haben keine Basis-Domain zum
 * Wechseln - dann bleibt der Sprung auf der aktuellen Origin (kein Absturz, aber auch kein
 * Tenant-Wechsel, der dort ohnehin nicht abbildbar ist).
 */
export function urlFuerSubdomain(label: string): string {
  const parts = window.location.hostname.split(".");
  const port = window.location.port ? `:${window.location.port}` : "";
  if (parts.length < 2) return `${window.location.protocol}//${window.location.host}/`;
  parts[0] = label;
  return `${window.location.protocol}//${parts.join(".")}${port}/`;
}
